import { generateArraySchema, generateObjectSchema, generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { TextParticleSpec, ButtonParticleSpec, PageParticleSpec, ImageParticleSpec, SearchParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Navigation Menu D", generateRootObjectSchema({
  container: generateAtomContainerSchema({
    defaultValues: { themeMode: 'primary' },
  }),
  backgroundColor: generateStringSchema('Background Color', 'Background color of the header.'),
  logoButton: ButtonParticleSpec.generateSchema('Logo Button', 'Logo Button in the header.'),
  teamButtons: generateArraySchema(
    'Team Buttons',
    'Team buttons in the navigation dropdown',
    ButtonParticleSpec.generateSchema('Team Button', 'Team button in the navigation dropdown')
  ),
  navigationLink: ButtonParticleSpec.generateSchema(
    'Navigation Link',
    'Navigation link at the top level of the desktop header.'
  ),
  items: generateArraySchema(
    'Items',
    'The array of top-level navigation-menu items.',
    generateObjectSchema('Item', 'A top-level navigation-menu item.', {}, { additionalProperties: true })
  ),
  hamburgerButton: ButtonParticleSpec.generateSchema('Hamburger Button', 'Hamburger button for the header.'),
  loginButton: ButtonParticleSpec.generateSchema('Login Button', 'Login button in the desktop header.'),
  tabletLoginButton: ButtonParticleSpec.generateSchema('Tablet Login Button', 'Login button in the tablet header.'),
  profileButton: ButtonParticleSpec.generateSchema('Profile Button', 'Profile button for the desktop header.'),
  hamburgerMenuPage: PageParticleSpec.generateSchema(
    'Hamburger Menu Page',
    'The page to embed in the hamburger menu.'
  ),
  dropdownIcon: ImageParticleSpec.generateSchema('Dropdown Icon', 'Dropdown icon of the navigation item'),
  dropdownHeading: TextParticleSpec.generateSchema('Dropdown Heading Text', 'Dropdown heading text'),
  dropdownLink: ButtonParticleSpec.generateSchema('Dropdown Links', 'Dropdown links'),
  searchButton: ButtonParticleSpec.generateSchema('Search Button', 'Search button'),
  searchBar: SearchParticleSpec.generateSchema('Search Bar Props', 'Search Bar Props'),
}));